import Api from './api';

const slug = 'v1/activities';
export default {
  getActivities(params) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/`, { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getActivitiesSharedByCouch(programSlug, params) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/program/${programSlug}/shared-by-couch`, { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getActivity(sessionId) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/${sessionId}`, {})
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  createActivity(activity) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/`, activity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateActivity(activity) {
    return new Promise((resolve, reject) => {
      Api.put(`/${slug}/${activity._id}`, activity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteActivity(activityId) {
    return new Promise((resolve, reject) => {
      Api.delete(`/${slug}/${activityId}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getProgramActivities(programSlug) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/program/${programSlug}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getVideoActivities(videoId) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/video/${videoId}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  computePersonalized(data) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/score-personalized`, data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
